import editorialStyle from "../../../components/editorial/style.scss";
import style from "./style.scss";

import { Fragment } from "preact";
import Link, { affiliateMerchants } from "../../../components/link";
import FixedTable from "../../../components/fixed-table";
import Accordion from "../../../components/accordion";
import NoWrap from "../../../components/no-wrap";
import namedRoutes from "../../../settings/routes";

import compatibilityData from "../data/alternator-chargers/compatibility.json";
import powerStationData from "../../../data/power-stations/ecoflow";

const formatNumber = (value, suffix, fallback = "--", digits = 0) => {
  return value
    ? `${new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      }).format(value)}${suffix}`
    : fallback;
};

const getRating = (product, powerLevel, connector) => {
  const chargers = product.chargers?.[powerLevel];
  if (!chargers) return "--";

  return formatNumber(chargers?.[connector], "W");
};

const renderTable = (products) => (
  <FixedTable frameless>
    <table>
      <thead>
        <tr>
          <th class={editorialStyle.sticky} />
          <th scope="col" colSpan={3}>
            600W Charger
          </th>
          <th scope="col" colSpan={3}>
            Plus 1000W Charger
          </th>
        </tr>
        <tr>
          <th scope="col" class={editorialStyle.sticky}>
            Model
          </th>

          <th scope="col">
            <mark class={style.xt60}>
              <strong>XT60</strong>
            </mark>
          </th>
          <th scope="col">
            XT150 <sup>1</sup>
          </th>
          <th scope="col">
            4+8 <sup>1</sup>
          </th>

          <th scope="col">
            XT60 <sup>1</sup>
          </th>
          <th scope="col">
            <mark class={style.xt150}>
              <strong>XT150</strong>
            </mark>
          </th>
          <th scope="col">
            4+8 <sup>1</sup>
          </th>
        </tr>
      </thead>
      <tbody>
        {products.map((product, index) => {
          const data = powerStationData?.powerStations[product.name];
          const has4plus8Port = product.ports?.["4+8"]?.count > 0;
          const hasMC4Port = product.ports?.MC4?.count > 0;

          return (
            <tr
              key={product.name}
              class={index === 0 ? editorialStyle.rowBorder : null}
            >
              <th scope="row" class={editorialStyle.sticky}>
                {data?.link?.href ? (
                  <Link
                    external
                    affiliateData={data.link.affiliateData}
                    affiliate={data.link.affiliate}
                    href={data.link.href}
                  >
                    {product.name}
                  </Link>
                ) : (
                  product.name
                )}{" "}
                {product["name"] === "DELTA Pro 3" ? <sup>3</sup> : null}
              </th>

              <td>
                <NoWrap>
                  <strong class={style.xt60}>
                    {getRating(product, "600", "XT60")}
                  </strong>{" "}
                  {hasMC4Port && product.chargers?.["600"]?.["XT60"] > 0 ? (
                    <sup>4</sup>
                  ) : null}
                </NoWrap>
              </td>
              <td>
                <NoWrap>
                  {getRating(product, "600", "expansionPort")}{" "}
                  {has4plus8Port ? <sup>2</sup> : null}
                </NoWrap>
              </td>
              <td>
                {has4plus8Port
                  ? getRating(product, "600", "expansionPort")
                  : "--"}
              </td>

              <td class={editorialStyle.cellDarken}>
                {getRating(product, "Plus 1000", "XT60")}
              </td>
              <td class={editorialStyle.cellDarken}>
                <NoWrap>
                  <strong>
                    {getRating(product, "Plus 1000", "expansionPort")}
                  </strong>{" "}
                  {has4plus8Port ? <sup>2</sup> : null}
                </NoWrap>
              </td>
              <td class={editorialStyle.cellDarken}>
                {has4plus8Port
                  ? getRating(product, "Plus 1000", "expansionPort")
                  : "--"}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </FixedTable>
);

const Module = ({ showPageLink = false }) => {
  const accordionItems = Object.entries(compatibilityData).map(
    ([seriesName, products], index) => ({
      heading: seriesName,
      content: renderTable(products),
      open: index === 0, // first section open by default
    })
  );

  return (
    <Fragment>
      <Accordion headingsAs="h3" disableContentPadding items={accordionItems} />

      <p class="caption">
        {showPageLink ? (
          <Fragment>
            Direct link to{" "}
            <Link href={namedRoutes.ecoflow.altCharger.gen2Compatibility}>
              compatibility page
            </Link>
            .
          </Fragment>
        ) : null}{" "}
        All compatibility data was confirmed with EcoFlow support.{" "}
        <strong>1.</strong> Accessory output cable sold separately.{" "}
        <strong>2.</strong> Requires{" "}
        <Link
          affiliateData={affiliateMerchants.ecoflow}
          href="https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393"
        >
          Smart Generator Adapter
        </Link>{" "}
        to use XT150 Output Cable. <strong>3.</strong> DELTA Pro 3 supports dual
        alternator chargers for combined maximum of 1700W (new charger model
        only). <strong>4.</strong> DELTA Pro Ultra requires custom{" "}
        <Link href={namedRoutes.ecoflow.deltaProUltra.xt60Compatibility}>
          XT60 to MC4 adapter
        </Link>
        .
      </p>
    </Fragment>
  );
};

export default Module;
